module.exports = __webpack_public_path__ + "static/media/ini1-90w.3006ba27.jpg";